import React, { useEffect } from "react";

// import { Link } from "react-router-dom";
import { __ } from "services/Translator";

export default function SportsBetting(props) {
  var params = {
    token: "{{$token}}",
    skinId: "jokercasino",
    walletcode: "230320",
    lang: "en",
  };

  var ASb = null;

  const loadAltenarSportsBook = () => {
    if (window.AltenarSportsbook) {
      // clearInterval(clearIntervalSportsBook);
      ASb = new window.AltenarSportsbook("#altenarsportsbook", params);
    }
  };

  useEffect(() => {
    loadAltenarSportsBook();
  }, []);

  return (
    <>
      <div id="altenarsportsbook"></div>
    </>
  );
}
